import React from 'react';
import styled from 'styled-components';
import tw from 'tailwind.macro';

const Label = styled('label')`
  ${tw`font-bold uppercase tracking-wide block mb-2 text-sm`}
`;

export default Label;


// WEBPACK FOOTER //
// ./src/components/Form/Label.js